const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MES_ERROR_REPORTS)

export const apiMesErrorReports = {
	fetchMesErrorReports: async (
		page: number = 1,
		perPage: number = 25,
		filters?: IApiFilters,
		sort?: Record<string, EApiSortType>,
	): Promise<IApiResponseModel<IProductionErrorModel[]>> => {
		const { data, meta } = await apiCommon<IProductionError[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, filters, sort),
		})

		return { data: data.map(d => productionError(d)), meta }
	},

	fetchMesErrorReport: async (id: number): Promise<IProductionErrorModel> => {
		const { data } = await apiCommon<IProductionError>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return productionError(data)
	},

	fetchMesErrorReportsBadgeCount: async (): Promise<{ count: number }> => {
		const { data } = await apiCommon<{ count: number }>(`${groupPrefix}/badge-count`, {
			method: 'GET',
		})

		return data
	},

	updateMesErrorReportStatus: async (
		id: number,
		status: EProductionErrorStatus,
	): Promise<IApiResponseModel<IProductionErrorModel>> => {
		const { data, meta } = await apiCommon<IProductionError>(`${groupPrefix}/${id}/status`, {
			method: 'PATCH',
			body: { status },
		})

		return { data: productionError(data), meta }
	},

	assignMesErrorReportToEmployee: async (
		issueID: number,
		assignedToEmployeeID: number,
	): Promise<IProductionErrorModel> => {
		const { data } = await apiCommon<IProductionError>(`${groupPrefix}/${issueID}/assigned-to`, {
			method: 'PATCH',
			body: { assigned_to_employee_id: assignedToEmployeeID },
		})

		return productionError(data)
	},

	createMesErrorReportComment: async (issueID: number, comment: string): Promise<IProductionErrorCommentModel> => {
		const { data } = await apiCommon<IProductionErrorComment>(`${groupPrefix}/${issueID}/comments`, {
			method: 'POST',
			body: { comment },
		})

		return productionErrorComment(data)
	},

	markMesErrorReportCommentAsReadCrm: async (issueID: number, commentID: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${issueID}/comments/${commentID}/read/crm`, {
			method: 'POST',
			body: {},
		})
	},

	fetchMesErrorReportsAssignableEmployees: async (): Promise<IEmployeeModel[]> => {
		const { data } = await apiCommon<IEmployee[]>(`${groupPrefix}/assignable-employees`, {
			method: 'GET',
		})

		return data.map(employee => Employee(employee))
	},
}
